(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Handle Mobile Drawer Interactivity Actions
  document.addEventListener('DOMContentLoaded', () => {
    const filterBtn = document.querySelector('.sf-toolbar-filter-btn');
    const sidebar = document.querySelector('.sf-sidebar');
    const closeBtn = document.querySelector('.sf-drawer-close');
    const overlay = document.querySelector('.sf-drawer-overlay');

    if (filterBtn && sidebar && overlay) {
      // Open Drawer
      filterBtn.addEventListener('click', (e) => {
        e.preventDefault();
        sidebar.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // Stop background scrolling
      });

      // Close Functions
      const closeDrawer = () => {
        sidebar.classList.remove('active');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      };

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
